// PostHog cargado DESPUÉS de pintar la app.
//
// posthog-js pesa ~70 KB comprimido y no hace falta para mostrar nada: antes
// iba en el paquete principal y retrasaba la primera pantalla (login/inicio
// ~6 s de p95 en Sentry en móviles con 4G, 2026-10-17). Ahora se importa
// cuando la página ya ha cargado; las llamadas de antes se guardan en cola y
// se envían en cuanto está listo.

let ph = null
const queue = []

function call(method, ...args) {
  if (ph) {
    try { ph[method](...args) } catch { /* no romper la app por analítica */ }
  } else {
    queue.push([method, args])
  }
}

// Sin identify: las estadísticas no se asocian a la persona (ni id, ni email,
// ni nombre). Decisión 2026-10-19 para no necesitar consentimiento previo
// (LSSI art. 22 / RGPD) — ver la política de privacidad 2026-10, punto 10.
export const analytics = {
  capture: (...a) => call('capture', ...a),
}

export function initAnalytics(key, host) {
  if (!key) return
  const start = () => {
    import('posthog-js').then(({ default: posthog }) => {
      posthog.init(key, {
        api_host: host,
        // Nada guardado en el dispositivo (ni cookie ni localStorage): cada
        // visita es anónima. Sin perfiles de persona, sin grabar sesiones ni
        // encuestas, y sin textos de la pantalla en los clics (pueden llevar
        // nombres de jugadores).
        persistence: 'memory',
        person_profiles: 'never',
        disable_session_recording: true,
        disable_surveys: true,
        mask_all_text: true,
        mask_all_element_attributes: true,
        capture_pageview: true,
        capture_pageleave: true,
      })
      ph = posthog
      queue.splice(0).forEach(([method, args]) => call(method, ...args))
    }).catch(() => { /* sin red o bloqueado por el navegador: sin analítica */ })
  }
  // `load` llega antes de que React pinte la pantalla (las pantallas se cargan
  // aparte): con solo eso PostHog (~76 KB + grabador y encuestas ~100 KB)
  // seguía compitiendo con el logo y el login. Se espera un poco más.
  const later = () => setTimeout(start, 3000)
  if (document.readyState === 'complete') later()
  else window.addEventListener('load', later, { once: true })
}
